import React, {useState} from 'react';
import {injectIntl} from "react-intl";

import SelectTitle from "components/radioGroup/SelectTitle";
import RadioGroup from "components/radioGroup/RadioGroup";
import FormControlLabel from "components/radioGroup/FormControlLabel";

import {useFormikContext} from "formik";


function TestingField(props) {
    const {values, setFieldValue} = useFormikContext();

    const yesLabel = props.intl.formatMessage({id: 'compliance.dac7.form.field.testing.yes'});
    const noLabel = props.intl.formatMessage({id: 'compliance.dac7.form.field.testing.no'});

    const testingValues = [
        {
            'label': yesLabel,
            'value': true,
        },
        {
            'label': noLabel,
            'value': false,
        }
    ];

    return (
        <>
            <SelectTitle required={true} titleTranslationKey='compliance.dac7.form.field.testing'/>
            <RadioGroup
                alignListWithButton
                selectedValueLabel={values.testing ? yesLabel : noLabel}
                name={'testing'}
                value={values.testing}
                onChange={(e) => setFieldValue("testing", Boolean(e.target.value))}
            >
                {testingValues.map((choice) => (
                    <FormControlLabel
                        key={choice.label}
                        value={choice.value}
                        label={choice.label}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default injectIntl(TestingField);
